/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Related_Title1Inputs */

const id_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Terkait`)
};

const ms_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Berkaitan`)
};

const da_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relaterede Tilbud`)
};

const de_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandte Angebote`)
};

const en_us2_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related Offers`)
};

const es_es2_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos relacionados`)
};

const es_mx2_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas relacionadas`)
};

const fil_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Kaugnay na Offer`)
};

const fr_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres liées`)
};

const it_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte correlate`)
};

const hu_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapcsolódó ajánlatok`)
};

const nl_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerelateerde aanbiedingen`)
};

const no_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relaterte tilbud`)
};

const pl_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiązane oferty`)
};

const pt_br2_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos relacionados`)
};

const pt_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas relacionadas`)
};

const ro_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte înrudite`)
};

const fi_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liittyvät tarjoukset`)
};

const sv_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relaterade erbjudanden`)
};

const vi_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi liên quan`)
};

const tr_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlgili Teklifler`)
};

const cs_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Související nabídky`)
};

const bg_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свързани оферти`)
};

const ru_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связанные предложения`)
};

const uk_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пов'язані пропозиції`)
};

const ar_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض ذات الصلة`)
};

const hi_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संबंधित ऑफ़र`)
};

const th_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอที่เกี่ยวข้อง`)
};

const ja_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関連オファー`)
};

const zh_cn2_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相关目录项`)
};

const zh_hant1_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相關目錄項目`)
};

const ko_offerdetail_related_title1 = /** @type {(inputs: Offerdetail_Related_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관련 오퍼`)
};

/**
* | output |
* | --- |
* | "Related Offers" |
*
* @param {Offerdetail_Related_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_related_title1 = /** @type {((inputs?: Offerdetail_Related_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Related_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_related_title1(inputs)
	if (locale === "ms") return ms_offerdetail_related_title1(inputs)
	if (locale === "da") return da_offerdetail_related_title1(inputs)
	if (locale === "de") return de_offerdetail_related_title1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_related_title1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_related_title1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_related_title1(inputs)
	if (locale === "fil") return fil_offerdetail_related_title1(inputs)
	if (locale === "fr") return fr_offerdetail_related_title1(inputs)
	if (locale === "it") return it_offerdetail_related_title1(inputs)
	if (locale === "hu") return hu_offerdetail_related_title1(inputs)
	if (locale === "nl") return nl_offerdetail_related_title1(inputs)
	if (locale === "no") return no_offerdetail_related_title1(inputs)
	if (locale === "pl") return pl_offerdetail_related_title1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_related_title1(inputs)
	if (locale === "pt") return pt_offerdetail_related_title1(inputs)
	if (locale === "ro") return ro_offerdetail_related_title1(inputs)
	if (locale === "fi") return fi_offerdetail_related_title1(inputs)
	if (locale === "sv") return sv_offerdetail_related_title1(inputs)
	if (locale === "vi") return vi_offerdetail_related_title1(inputs)
	if (locale === "tr") return tr_offerdetail_related_title1(inputs)
	if (locale === "cs") return cs_offerdetail_related_title1(inputs)
	if (locale === "bg") return bg_offerdetail_related_title1(inputs)
	if (locale === "ru") return ru_offerdetail_related_title1(inputs)
	if (locale === "uk") return uk_offerdetail_related_title1(inputs)
	if (locale === "ar") return ar_offerdetail_related_title1(inputs)
	if (locale === "hi") return hi_offerdetail_related_title1(inputs)
	if (locale === "th") return th_offerdetail_related_title1(inputs)
	if (locale === "ja") return ja_offerdetail_related_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_related_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_related_title1(inputs)
	return ko_offerdetail_related_title1(inputs)
});
export { offerdetail_related_title1 as "offerDetail.related.title" }